import React, { useRef, useState, useEffect } from 'react';
import './indi.css';
import { Navigate, useNavigate, Link} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Modal from 'react-modal';
import FormData from 'form-data';
import dayjs from 'dayjs';
import {he} from './store';
Modal.setAppElement('#root');

const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    
    },
  };

const Sins=()=>{

    const [Files, setFiles] = useState({poster : '', info : []});
   
    const [ddd, setddd] = useState(0);
    const [spin, setspin] = useState(false);
    const [progress, setprogress]= useState(0);
    const [monjo, setmonjo] = useState(false);
    const [pant, setpant] = useState(false);
    const [idname, setidname] = useState();
    const [coo, setcoo] = useState([]);
    const [bbal, setbbal] = useState();
    const [nodak, setnodak] = useState(false);
    const [cate, setcate] = useState(false);
    const [mms, setmms] = useState("150px");
    const fale = useSelector(state => state.mahena);
    const histo = useNavigate();
    const dispatch = useDispatch();

const checkmin =(e)=>{
if(e.target.name == 'poster'){
    const compa =  5*1024*1024;
    document.getElementById("piano").textContent = "";
    const prh = document.querySelector('#yorksh');
            const files = Array.from(e.target.files);
            for(let f in files){
                if(files[f].size > compa){
                    e.target.value = "";
                    document.getElementById("piano").textContent = "5MB 이하로 업로드해주세요";
                    return;
                }; 
            };
          
            if(prh.children.length > 0){
                prh.removeChild(prh.firstElementChild);
            };
            files.forEach(file => {
                const parx = document.createElement('p');
                parx.id = file.lastModified;
                const button = document.createElement('button');
                button.onclick = rekoa;
                button.dataset.index = file.lastModified;
                button.innerText = "X";
                button.style.marginLeft = "5px";
                parx.innerText = file.name;
                parx.style.marginTop = "6px";
                parx.style.marginBottom = "6px";
                parx.appendChild(button);
                prh.appendChild(parx); 
            });
    setFiles({...Files, poster : e.target.files[0]});
}
    };

const rekoa=(e)=>{
    e.preventDefault();
    const removeTargetId = e.target.dataset.index;
    const removeTarget = document.getElementById(removeTargetId);
 
    removeTarget.remove();
    setFiles({...Files, poster : ''});
};    

const removes=(e)=>{
    e.preventDefault();

    const removeTargetId = e.target.dataset.index;
    const removeTarget = document.getElementById(removeTargetId);

    const files = document.getElementsByName('info')[0].files;
 
    
    const dataTranster = new DataTransfer();      
    Array.from(files).filter(file => file.lastModified != removeTargetId)
                    .forEach(file => {dataTranster.items.add(file);});
    document.getElementsByName('info')[0].files = dataTranster.files;

   
    setFiles({...Files, info : [...dataTranster.files]});
    removeTarget.remove();
};

const checkfo =(e)=>{
        if(e.target.name == 'info'){
            const compa =  5*1024*1024;
            document.getElementById("giano").textContent = "";
            const prh = document.querySelector('#worksh');
            const files = Array.from(e.target.files);
            if(files.length + Files.info.length > 5){
                document.getElementById("giano").textContent = "업로드 파일은 최대 5개입니다";
                return;
            };
            for(let f in files){
                if(files[f].size > compa){
                    e.target.value = "";
                    document.getElementById("giano").textContent = "5MB 이하로 업로드해주세요";
                    return;
                }; 
            };
            files.forEach(file => {
                const parx = document.createElement('p');
                parx.id = file.lastModified;
                const button = document.createElement('button');
                button.onclick = removes;
                button.dataset.index = file.lastModified;
                button.innerText = "X";
                button.style.marginLeft = "5px";
                parx.innerText = file.name;
                parx.style.marginTop = "6px";
                parx.style.marginBottom = "6px";
                parx.appendChild(button);
                prh.appendChild(parx); 
            });
            if(Files.info.length > 0){
             
                const dataTranster = new DataTransfer();      
                Array.from([...Files.info, ...e.target.files]).forEach(file => {dataTranster.items.add(file);});
                document.getElementsByName('info')[0].files = dataTranster.files;
             
                setFiles({...Files, info : [...dataTranster.files]});
            }else{
            setFiles({...Files, info : [...e.target.files]});
            };
        }
            };
         
            document.title = "공모전 등록 - 돌파공모";
const prepro =(ra)=>{
        if (!ra) return '';
              
        let clean = ra;
        clean = clean.toLowerCase();
        const yearRegex = /[([{\s]?(19|20)\d{2}년?[)\]}\s]?/g;
        clean = clean.replace(yearRegex, '');
                    
        const episodeRegex = /(?:제\s?)?\d+(화|회|부|탄|편)|\b\d+화\b|#\d+/g;
        clean = clean.replace(episodeRegex, '');
              
        const punctuationRegex = /[\[\]\(\)\-\_]/g;
        clean = clean.replace(punctuationRegex, ' ');
            
        clean = clean.replace(/\s+/g, ' ').trim();
              
        return clean;
        };

const sss = async (e) =>{
    e.preventDefault();
    const checkb = document.querySelectorAll('input[type="checkbox"]:checked');
    if(checkb.length == 0){
        setcate(true);
        document.getElementById("haca").scrollIntoView({behavior:"smooth", block:"center"});
        return;
    }
   
    const nnn = e.target.kog.value;
    // const sizz = new Date(e.target.sizak.value).getTime();
    // const sizg = parseInt(sizz);
    const sizac = dayjs(e.target.sizak.value).format("YYYY-MM-DD");
    // const zonn = new Date(e.target.zong.value).getTime();
    // const zizg = parseInt(zonn);
    const zizac = dayjs(e.target.zong.value).format("YYYY-MM-DD");
   
    const fortoday = dayjs().format("YYYY-MM-DD HH:mm:ss");
    const ortoday = dayjs().format("YYYY-MM-DD");
    const airon = nnn.toLowerCase().trim().split(" ");
    const diver = document.getElementById('jop').innerHTML;
 
    if(nnn.trim().length === 0){
        document.getElementById("kog-error").scrollIntoView({behavior:"smooth", block:"center"});
        document.getElementById("kog-error").textContent = "공모전 명칭을 입력해주세요";
        return;
    };
    if(!e.target.sizak.value){
        document.getElementById("sizak-error").scrollIntoView({behavior:"smooth", block:"center"});
        document.getElementById("sizak-error").textContent = "시작일을 입력해주세요";
        return;
    };
    if(!e.target.zong.value){
        document.getElementById("zong-error").scrollIntoView({behavior:"smooth", block:"center"});
        document.getElementById("zong-error").textContent = "마감일을 입력해주세요";
        return;
    };
    if(diver.trim().length === 0){
        document.getElementById("jopab").scrollIntoView({behavior:"smooth", block:"center"});
        document.getElementById("jopab").textContent = "공모요강을 입력해주세요";
        return;
    };
    if(e.target.designer.value.trim().length === 0){
        document.getElementById("designer-error").scrollIntoView({behavior:"smooth", block:"center"});
        document.getElementById("designer-error").textContent = "주최사를 입력해주세요";
        return;
    };
    if(e.target.holder.value.trim().length === 0){
        document.getElementById("holder-error").scrollIntoView({behavior:"smooth", block:"center"});
        document.getElementById("holder-error").textContent = "주관사를 입력해주세요";
        return;
    };
    const posterInput = e.target.elements?.poster || e.target.poster;
    if (!posterInput || !posterInput.files || posterInput.files.length === 0) {
        document.getElementById("piano").scrollIntoView({behavior:"smooth", block:"center"});
        document.getElementById("piano").textContent = "포스터를 업로드해주세요";
        return;
    };

    setspin(true);
    const shot = new FormData();
    shot.append('poster', Files.poster);
   // shot.append('info', Files.info);
    shot.append('title', nnn);
    shot.append('designer', e.target.designer.value);
    shot.append('holder', e.target.holder.value);
    shot.append('tels', e.target.tels.value);
    shot.append('hpage', e.target.wpage.value);
    shot.append('firday', sizac);
    shot.append('enday', zizac);
    shot.append('fortoday', fortoday);
    shot.append('story', diver);
    shot.append('posts', JSON.stringify(fale.post));
    shot.append('search', prepro(nnn));
    //shot.append('one', e.target.one.value);
    if(Files.info.length > 0) {
        Files.info.map((kona,i)=>shot.append('info',kona));
    }else{
        shot.append('info', "");
    };
    // if(airon.length > 1){
    //     airon.map((jon,i)=>shot.append('search', jon));
    // }else{
    //     let dodi = [];
    //     dodi.push(airon);
       
    //     shot.append('search', dodi);
    // };
    if(coo.length > 1){
        coo.map((oaa,i)=>shot.append('categol', oaa));
      
    }else{
        let cooa = [];
        shot.append('categol', coo);
       
    };
    if(coo.includes("대외활동")){
        shot.append('color', 1);
    }else if(coo.includes("교육")){
        shot.append('color', 2);
    }else{
        shot.append('color', 0);
    };
        
    // let entries = shot.entries();
    // for (const pair of entries) {
   
    // };
  
/*
 transformRequest: (data, headers) => {
        return data;
      },
    onUploadProgress : data=>{setprg(Math.round((100*data.loaded)/data.total))}
*/
    const oiu = await axios.post('/api/starts',shot, {headers: {"Content-Type" : "multipart/form-data"}})
    .then(eah=>{ setspin(false); setmonjo(true); dispatch(he({...fale, post : JSON.parse(eah.data)})); 
    setTimeout(() => {histo('/', {replace : true}); }, 3000); }).catch(err=>{
        if(err.response?.data?.success == "overvolume"){
            document.getElementById("piano").textContent = "5MB 이하로 업로드해주세요";
        };
        if(err.response?.data?.success == "overtotal"){
            document.getElementById("giano").textContent = "업로드 파일은 최대 5개입니다";
        };
        if(err.response?.data?.success == "posterneed"){
            document.getElementById("piano").textContent = "포스터를 업로드해주세요";
        };
        if(err.response?.data?.success == "overfile"){
            document.getElementById("giano").textContent = "5MB 이하로 업로드해주세요";
        };
        if(err.response?.data?.success == "rollover"){
            const yein = err.response?.data?.missing;
            if(yein === "title"){ 
                document.getElementById("kog-error").scrollIntoView({behavior:"smooth", block:"center"});
                document.getElementById("kog-error").textContent = "공모전 명칭을 입력해주세요";
            } else if(yein === "designer"){
                document.getElementById("designer-error").scrollIntoView({behavior:"smooth", block:"center"});
                document.getElementById("designer-error").textContent = "주최사를 입력해주세요"; 
            } else if(yein === "holder"){
                document.getElementById("holder-error").scrollIntoView({behavior:"smooth", block:"center"});
                document.getElementById("holder-error").textContent = "주관사를 입력해주세요";
            } else if(yein === "firday"){
                document.getElementById("sizak-error").scrollIntoView({behavior:"smooth", block:"center"});
                document.getElementById("sizak-error").textContent = "시작일을 입력해주세요";
            } else if(yein === "enday"){
                document.getElementById("zong-error").scrollIntoView({behavior:"smooth", block:"center"});
                document.getElementById("zong-error").textContent = "마감일을 입력해주세요";
            };
        };
        setspin(false);});
}; 

const checkall= async (e)=>{
    e.preventDefault();
}
const nana = useRef();
//const downing = getDownloadURL(download).then(x=>{console.log("innerX",x); nana.current.innerHTML = `<a href=${x} class="fang" download>documents</a>`; return x;}).catch(err=>console.log(err));
let xxx = 0;
const golla = ["응모 자격", "응모 형식", "일정 및 기간", "시상 내역", "접수 방법", "문의처", "유의사항", "특전", "홍보영상", "기타"];

const deoha=(e)=>{
    e.preventDefault();
    if(ddd>9){return;};
   const koll = golla[ddd];
    
    const seled = document.querySelector('.ppls');
    const koong = document.createElement('tr');
    koong.innerHTML=`<th><span><input type="text" name="one${ddd}" placeholder="${koll}" value="${koll}"/></span></th>
    <td><div id='jop${ddd}' class='pluswrite' contentEditable='true'></div></td>`;
    seled.insertAdjacentElement('beforebegin',koong);
    document.getElementById(`jop${ddd}`).focus();
    setidname(`jop${ddd}`);
    setddd(ddd+1);
    xxx++;
};

const bbold=(e)=>{
    e.preventDefault();
  
    let pong =[];
    let ranges =[];
    const sel = document.getSelection();
    if(sel.type == "None"){return};
    
    const zel =  sel.getRangeAt(0).cloneContents();
    const yel = sel.getRangeAt(0);
    if(yel.commonAncestorContainer.nodeName == 'SPAN' || yel.commonAncestorContainer.nodeName == 'TD'|| yel.commonAncestorContainer.nodeName == 'BUTTON'){return};
    const nums = zel.childNodes.length;
   
    if(yel.commonAncestorContainer.nodeName == '#text'|| yel.commonAncestorContainer.nodeName == 'DIV'){
        const papen = yel.extractContents();
     
        if(papen.childNodes.length>1){
            const lac = papen.childNodes.forEach(a=>{ranges.push(a.textContent);});
          
            let toal = document.createElement('div');
            for(let g=0; g<ranges.length; g++){
                const macc = document.createElement('p');
                const hacc = document.createElement('b');
                hacc.innerText = ranges[g];
                macc.appendChild(hacc);
                toal.innerHTML += macc.outerHTML;
                
            };
            yel.insertNode(toal);
          
        }else{
           
            const makerag = document.createElement('b');
            makerag.innerText = zel.textContent;
            yel.insertNode(makerag);
       
        };
    }else{
   // sel.getRangeAt(0).extractContents();
    const yess = yel.startContainer.parentNode;
    const ness = yel.endContainer.parentNode;
   
   const kess = yel.startContainer.parentNode.firstChild;
   const so1 = zel.firstChild.firstChild;
   const so2 = document.createElement('b');
   so2.innerText = zel.firstChild.textContent;
   zel.firstChild.replaceChild(so2, so1);
  
  
    let koha = yess;
    let couns =1;
    while(couns<=nums){
      
      
        let older = koha.firstChild;
        const newer = document.createElement('b');
        newer.innerText = older.textContent;
        koha.replaceChild(newer, older);
        koha = koha.nextSibling;
        couns++;
    };
    
};
};

const oggle =(e)=>{

isMouseDown = true; 
//startCellIndex = e.target.parentNode;
startCellIndex = e.currentTarget.cellIndex;
startcellorigin = e.currentTarget.getAttribute("origins");
startcellcol = e.currentTarget.getAttribute("colspan");
startcellrow = e.currentTarget.getAttribute("rowspan") ? parseInt(e.currentTarget.getAttribute("rowspan")) : 1;
startRowIndex = e.currentTarget.parentNode.rowIndex;
        //startRowIndex = e.target.parent().index();

//e.currentTarget.classList.toggle('selected');
// return false;
};

const tama=(e)=>{
    e.preventDefault();
    const hang = e.target.dataset.info;
    const yell = e.target.dataset.non;
    const cheom = document.createElement('table');
    cheom.addEventListener('mousedown', (e)=>{
        
        const tavs = cheom.getElementsByTagName('td');
      
        for(let i = 0; i<tavs.length; i++){
            tavs[i].onmousedown = oggle;
           tavs[i].onmouseover = dragover;
           tavs[i].onmouseup = dragoff;
        };
        if(document.getElementById('sooja')){
            document.getElementById('sooja').remove();
        };
});
   // cheom.addEventListener('mouseover', dragover);
  //  cheom.addEventListener('mouseup', dragoff);

    const tubon = document.createElement('tbody');
    for(let i=0; i<hang; i++){
        const row =document.createElement('tr');
        for(let j=0; j<yell; j++){
            const cell = document.createElement('td');
            cell.setAttribute("height", "18px");
            cell.setAttribute("width", "150px");
            cell.setAttribute("origins", j);
            cell.setAttribute("colspan", 1);
            const texing = document.createElement('p');
            //const cellin = document.createTextNode("");
            const cellin = document.createTextNode('\u00a0');
            texing.appendChild(cellin);
            cell.appendChild(texing);
            row.appendChild(cell);
        };
        tubon.appendChild(row);
    }; 
    cheom.appendChild(tubon);
    const bbody = document.getElementById(idname);
    bbody.appendChild(cheom);
    cheom.setAttribute("border", "2");
    cheom.setAttribute("oricells", yell-1);
    cheom.classList.add('yomiw');
    const sppa = document.createElement('br');
    cheom.insertAdjacentElement('afterend',sppa);
};
/*
cheom.find("td").mousedown(function (e) {
    isMouseDown = true;
    let cell = this;
    console.log("this는",this);

    cheom.find(".selected").removeClass("selected"); // deselect everything
    
    if (e.shiftKey) {
        selectTo(cell);                
    } else {
        cell.addClass("selected");
        startCellIndex = cell.index();
        startRowIndex = cell.parent().index();
    }
    
    return false; // prevent text selection

    .prevent-select {
  -webkit-user-select: none;
  -ms-user-select: none; 
  user-select: none; 
}
});
*/

let isMouseDown = false;
let startRowIndex = null;
let startCellIndex = null;
let startcellorigin = null;
let startcellcol = null;
let startcellrow = null;

function selectTo(cell) {
    
    const kize =  document.querySelectorAll(".selected");
   
   if(kize.length > 0){
        kize.forEach((a)=>{a.classList.remove("selected");});
    };
    
    //let row = cell.parent();    
   // let cellIndex = cell.index();
    //let rowIndex = row.index();
    let cellIndex = cell.cellIndex;
    let cellorigin = cell.getAttribute("origins");
    let roworigin = cell.getAttribute("rowspan") ? parseInt(cell.getAttribute("rowspan")) : 1;
    let rowIndex = cell.parentNode.rowIndex;

    const table = cell.parentNode.parentNode.parentNode;
    const tablezoo = table.rows.length;
    const sisa = table.querySelectorAll("p");
    sisa.forEach((a)=>{a.classList.add("preventselect");});
    let rowStart, rowEnd, cellStart, cellEnd;
    let lastk =0;
    
    for(let m=0; m<=cellIndex; m++){
    lastk += table.rows[rowIndex].cells[m].getAttribute("colspan") ? parseInt(table.rows[rowIndex].cells[m].getAttribute("colspan")) : 1;
    };
    

   
    if (rowIndex < startRowIndex) {
        rowStart = rowIndex;
        rowEnd = startRowIndex;
    } else {
        rowStart = startRowIndex;
        rowEnd = rowIndex;
    }
    
    const dooson = [rowIndex + roworigin -1, startcellrow + startRowIndex -1, rowIndex, startRowIndex];
    let teroo = Math.max(...dooson); //마지막행 인덱스
    let taroo = Math.min(...dooson); //첫행 인덱스
    rowStart = taroo;
    rowEnd = teroo;
    

    // if (cellorigin < startcellorigin) {
    //     cellStart = cellorigin;
    //     cellEnd = startcellorigin;
    // } else {
    //     cellStart = startcellorigin;
    //     cellEnd = cellorigin;
    // };  


    if (cellorigin < startcellorigin) {
        cellStart = cellIndex;
        cellEnd = startCellIndex;
    } else if(cellorigin == startcellorigin) {
        if(startRowIndex > rowIndex){
            cellStart = cellIndex;
            cellEnd = startCellIndex;
        }else{
        cellStart = startCellIndex;
        cellEnd = cellIndex;
        };
    } else {
        cellStart = startCellIndex;
        cellEnd = cellIndex;
    };
  
    
    
    
    let cellking = 0; //행 소유 셀 개수 최대치
    let arra = []; //테이블 각 행의 칼럼수를 마지막 인덱스로 입력력
    let lier = []; //각 행의 셀 콜스팬 합, 인덱스을 소유한 셀의 가로길이 총합합
    let issy = 0;
    let zissy = 0; //가로길이 최대 
    let noonmul = []; //각 행의 칼럼 로우스팬 값이 있는 셀 정보 입력, 그 형식 - [행, 열, 로우스팬수, 콜스팬수]
    
    for(var i = 0; i < tablezoo; i++){
        var cellwoo = table.rows[i].cells.length - 1;
        if(cellwoo > cellking){
            cellking = cellwoo;
        };
        arra.push(cellwoo);
    };
    for(let k =0; k < tablezoo; k++){
        for(let c=0; c<=arra[k]; c++){
          issy += table.rows[k].cells[c].getAttribute("colspan") ? parseInt(table.rows[k].cells[c].getAttribute("colspan")) : 1; 
         if(table.rows[k].cells[c].getAttribute("rowspan")){
           let zohaso = parseInt(table.rows[k].cells[c].getAttribute("rowspan"));
           let daran = table.rows[k].cells[c].getAttribute("colspan") ? parseInt(table.rows[k].cells[c].getAttribute("colspan")) : 1; 
           noonmul.push([k,c,zohaso, daran]);
             };          
        };
        lier.push(issy);
        if(issy > zissy){
            zissy = issy;
        };
    };

    let appe = 0; //선택한 셀 중 첫번째의 왼쪽부터 가로로 떨어진 거리 오리진값으로 표기기
    if(noonmul.length > 0){
        for(const one of noonmul){  
            if(one[0] < rowStart && one[0]+one[2]-1 >= rowStart ){ 
                if(one[1] == 0){
                    if(cellStart == 0){
                        appe = one[3];
                    }else{
                        let yona = 0;
                        for(let b=0; b<cellStart; b++){
                            yona += table.rows[rowStart].cells[b].getAttribute("colspan") ? parseInt(table.rows[rowStart].cells[b].getAttribute("colspan")) : 1; 
                        };
                        appe = yona + one[3];
                    };
                }else{
                    let angi =0;
                    for(let n=0; n<one[1]; n++){
                    angi += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1 
                    };
                    let ingi =0;
                    for(let n=0; n<cellStart; n++){
                    ingi += table.rows[rowStart].cells[n].getAttribute("colspan") ? parseInt(table.rows[rowStart].cells[n].getAttribute("colspan")) : 1;
                    };
                    if(angi==ingi){
                        appe= angi + one[3];
                    }else if(ingi > angi){
                        appe = ingi + one[3];
                    }else if(ingi < angi){
                        appe = ingi;
                    }else{
                        appe = 0;
                    };
                };
            }else if(one[0] == rowStart && one[0] == rowEnd && cellEnd == one[1]){
                for(let n=0; n<cellStart; n++){
                    appe += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1 
                    };
                    rowEnd = one[0]+one[2]-1;
            }else{
               
                if(cellStart == 0){
                    appe = 0;
                }else{
                for(let b=0; b<cellStart; b++){
                 appe += table.rows[rowStart].cells[b].getAttribute("colspan") ? parseInt(table.rows[rowStart].cells[b].getAttribute("colspan")) : 1; 
                };
                };
               
            };
        };
    }else{
        if(cellStart == 0){
            appe = 0;
        }else{
        for(let b=0; b<cellStart; b++){
         appe += table.rows[rowStart].cells[b].getAttribute("colspan") ? parseInt(table.rows[rowStart].cells[b].getAttribute("colspan")) : 1; 
        };
        };
    };

    let duie = 0; //마지막 선택 셀의 가로길이 정보보
    if(noonmul.length == 11){
        for(const one of noonmul){
            if(one[0] < rowEnd && one[0]+one[2]-1 >=rowEnd){
           //셀엔드값이 맞지 않다
                if(one[1] == 0){
                    for(let n=0; n<=cellEnd; n++){
                        duie += table.rows[rowEnd].cells[n].getAttribute("colspan") ? parseInt(table.rows[rowEnd].cells[n].getAttribute("colspan")) : 1; 
                    };
                    duie = duie + one[3];
                }else{
                    if(startRowIndex == one[0]+one[2]-1 && rowIndex == one[0]){
                
                        for(let n=0; n<=cellIndex; n++){
                        duie += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1;
                        };
                    }else if(rowStart == one[0] && rowIndex == one[0] && cellEnd == one[1]){
                      
                        for(let n=0; n<=cellEnd; n++){
                            duie += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1;
                            };
                    }else{
                    let angi =0;
                    for(let n=0; n<one[1]; n++){
                    angi += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1 
                    };
                    let ingi =0;
                    for(let n=0; n<=cell.cellIndex; n++){
                    ingi += table.rows[rowEnd].cells[n].getAttribute("colspan") ? parseInt(table.rows[rowEnd].cells[n].getAttribute("colspan")) : 1;
                    };
                    if(angi>=ingi){
                        duie = ingi;
                    }else{
                        duie = ingi + one[3];
                    };
                };
                };
            }else if(one[0] < rowEnd && one[0]+one[2]-1 < rowEnd){
             
                let sigi = 0;
                for(let n=0; n<=cellEnd; n++){
                    sigi += table.rows[rowEnd].cells[n].getAttribute("colspan") ? parseInt(table.rows[rowEnd].cells[n].getAttribute("colspan")) : 1;
                    };
                duie = sigi;
            }else if(one[0] >= rowEnd){
                let sigi = 0;
                for(let n=0; n<=cellEnd; n++){
                    sigi += table.rows[rowEnd].cells[n].getAttribute("colspan") ? parseInt(table.rows[rowEnd].cells[n].getAttribute("colspan")) : 1;
                    };
                duie = sigi;
            };
            };
    }else if(noonmul.length > 0){
        if(cellorigin > startcellorigin){
            appe = startcellorigin;
            duie = parseInt(cellorigin) + parseInt(cell.getAttribute("colspan"));
            
        }else if(cellorigin == startcellorigin){
            appe = startcellorigin; 
            duie = Math.max(parseInt(cellorigin) + parseInt(cell.getAttribute("colspan")), parseInt(startcellorigin) + parseInt(startcellcol));
            
        }else{
            appe = cellorigin;
            duie = parseInt(startcellorigin) + parseInt(startcellcol);
           
        };
    }else{
        if(cellorigin == startcellorigin){
            const biho = parseInt(startcellcol) + parseInt(startcellorigin);
            const viho = parseInt(cellorigin) + parseInt(cell.getAttribute("colspan"));
            duie = Math.max(biho, viho);
        }else{
        for(let b=0; b<=cellEnd; b++){
            duie += table.rows[rowEnd].cells[b].getAttribute("colspan") ? parseInt(table.rows[rowEnd].cells[b].getAttribute("colspan")) : 1; 
           };
        };
    };

    let frank = 0; //appe와 동일한 값, 테이블의 최왼쪽부터 선택셀의 시작지점까지의 거리, 오리진으로 표기
    let backa = 0; //duie와 동일한 값, 테이블의 최왼쪽부터 선택셀의 마지막길이 포함 거리, 오리진 더하기 해당 셀 콜스팬팬
    if(cellorigin > startcellorigin){
        frank = startcellorigin;
        backa = parseInt(cellorigin) + parseInt(cell.getAttribute("colspan"));
        
    }else if(cellorigin == startcellorigin){
        if(rowIndex > rowStart){
            frank = startcellorigin;
            backa = parseInt(cellorigin) + parseInt(cell.getAttribute("colspan"));
        }else{
            frank = cellorigin;
            backa = parseInt(startcellorigin) + parseInt(startcellcol);
        };
    }else{
        frank = cellorigin;
        backa = parseInt(startcellorigin) + parseInt(startcellcol);
       
    };


   
//여기까지가 사전 작업 이후는 본작업업
let mingi = 0;
let fingi = 0;
    for(let i=rowStart; i<=rowEnd; i++){
        let cellv = cellStart;
        let cellz = cellEnd;
        let nogood = 0;   
      
        if(noonmul.length == 10){
            for(const one of noonmul){
                if(i == rowEnd && one[0] < i && one[0]+one[2]-1 > i){
                    if(one[1] == 0){
                        if(appe < one[3]){
                            return;
                        };
                    }else{
                        let temo = 0;
                        let sara = 0;
                        for(let p=0; p<one[1]; p++){
                        temo +=table.rows[one[0]].cells[p].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[p].getAttribute("colspan")) : 1;     
                        };
                        if(temo > appe && duie <= temo){
                         
                            sara = 1;
                        }else if(temo + one[3] <= appe && duie > temo + one[3]){
                           
                            sara = 1;
                        }else{
                            
                            sara = 0;
                        };
                        if(sara == 0){
                            document.querySelectorAll('.selected').forEach((a)=>{a.classList.remove("selected");});
                            return;
                        };
                    };
                };
                if(i == rowStart && one[0] < i && one[0]+one[2]-1 >= i ){
                    if(one[1] > 0){
                        let angi =0;
                    for(let n=0; n<one[1]; n++){
                       angi += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1 
                    };
                    if(duie >= one[3]+angi){
                        return;
                       };
                    };
                };
                if(one[0] < i && one[0]+one[2]-1 >=i){
                    if(one[1] == 0){
                        if(appe > 0 && appe < one[3]){
                            return;
                        }else if(appe == 0 && duie == one[3]){
                            
                            nogood = 1;
                        }else if(appe == 0 && duie > one[3]){
                            let ches = 0;
                            let hondo = one[3];
                            for(let j = 0; j <= arra[i]; j++){
                               hondo += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                               if(hondo == duie){
                                cellv = 0;
                                cellz = j;
                                ches = 1;
                                
                                break;
                               }; 
                            }; 
                           
                            if(ches == 0){
                            return;
                            };
                        }else if(appe > one[3]){
                            let jondo = one[3];
                            let cheone = 0;
                            let chetwo = 0;
                            for(let j = 0; j <= arra[i]; j++){
                                jondo += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                                if(jondo == appe){
                                 cellv = j+1;
                                 cheone = 1;
                                }; 
                                if(jondo == duie){
                                    cellz = j;
                                    chetwo = 1;
                                };
                             }; 
                             if(cheone == 0 || chetwo == 0){
                                return;
                             };
                        }else if(appe == one[3]){
                            let ches = 0;
                            let kondo = one[3];
                            for(let j = 0; j <= arra[i]; j++){
                                kondo += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                                if(kondo == duie){
                                    cellv = 0;
                                    cellz = j;
                                    ches = 1;
                                 break;
                                }; 
                             }; 
                             if(ches == 0){
                                return;
                             };
                        };
                    }else{
                        let angi =0;
                        for(let n=0; n<one[1]; n++){
                        angi += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1; 
                        };

                        if(appe == 0 && duie <= angi){
                            let hote = 0;
                            let chse = 0;
                            for(let j = 0; j <= arra[i]; j++){
                              hote += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                            if(duie == hote){
                                cellv = 0;
                                cellz = j;
                                chse = 1;
                            };
                            };
                            if(chse == 0){
                                return;
                            }   
                        }else if(appe == 0 && duie > angi){
                           if(duie == angi + one[3]){
                            let madome = 0;
                            for(let j = 0; j <= arra[i]; j++){
                     madome += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                              if(madome == angi){
                                cellv = 0;
                                cellz = j;
                              };
                            };
                           }else{
                            let gondo = one[3];
                            let ches = 0;
                            for(let j = 0; j <= arra[i]; j++){
                            gondo += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                        if(duie == gondo){
                            cellv = 0;
                            cellz = j;
                            ches = 1;
                        };   
                        };
                        if(ches == 0){
                            return;
                        };
                           };
                        }else if(appe > 0 && angi > appe){
                            //여기 다시 해봐
                            let gondo = 0;
                            let ches = 0;
                            for(let j = 0; j <= arra[i]; j++){
                                gondo += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                            if(gondo == appe){
                                cellv = j+1;
                                ches = 1;
                            };
                            };
                            let shas = 0;
                            if(duie == angi + one[3]){
                                let mado = 0;
                                for(let j=0; j<=arra[i]; j++){
                                  mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                                    if(angi == mado){
                                        cellz = j;
                                        shas = 1;
                                        break;
                                    };
                                };
                            };
                            if(duie < angi + one[3] && angi < duie){
                                shas = 0;
                            };
                            if(duie <= angi){
                                let mado = 0;
                                for(let j=0; j<=arra[i]; j++){
                                  mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                                    if(duie == mado){
                                        cellz = j;
                                        shas = 1;
                                        break;
                                    };
                                };
                            };
                            if(duie > angi+one[3]){
                                let mado = 0;
                                for(let j=0; j<=arra[i]; j++){
                                  mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                                  if(mado + one[3] == duie){
                                    cellz = j;
                                    shas = 1;
                                    break;
                                  };  
                                };
                            };
                        
                            if(ches == 0 || shas == 0){
                                return;
                            };
                        }else if(appe > 0 && angi == appe){
                            let shas = 0;
                            let chas = 0;
                            if(duie < angi+one[3] && angi <duie){
                                return;
                            };
                            if(duie == angi+one[3]){
                   
                    nogood = 1;
                    continue;
                            };
                          
                            if(duie > angi+one[3]){
                                
                                let mado = one[3];
                                for(let j=0; j<=arra[i]; j++){
                                  mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                                  if(appe + one[3] == mado){
                                    cellv = j+1;
                                    shas = 1;
                                    };
                                  if(duie == mado){
                                        cellz = j;
                                        chas = 1;
                                    };
                                   
                                };
                            };
                           
                            if(shas == 0 || chas == 0){
                                return;
                            };
                        }else if(appe > 0 && appe > angi){
                           
                            let shas = 0;
                            let chas = 0;
                            if(appe < angi+one[3]){
                               return;     
                            };
                            if(appe >= angi+one[3]){
                             
                                let mado = one[3];
                                for(let j=0; j<=arra[i]; j++){
                                  mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                                  if(appe == mado){
                                    cellv = j+1;
                                    shas = 1;
                                    };
                                  if(duie == mado){
                                        cellz = j;
                                        chas = 1;
                                    };
                                };
                            };
                            if(shas == 0 || chas ==0){
                                return;
                            };
                        };
                    };

                }else if(one[0] == i){
                   
                    if(i == rowStart && i == rowIndex){
                        
                        if(cellEnd <= one[1]){
                         cellv = cellStart;
                         cellz = cellEnd;
                        }else if(cellEnd > one[1]){
                            if(cellStart > one[1]){
                                let shas = 0;
                                let chas = 0;
                                let mado = 0;
                                let miorgi = 0;
                                for(let j=0; j<=arra[i]; j++){
     mado = table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) + parseInt(table.rows[i].cells[j].getAttribute("origins")) : parseInt(table.rows[i].cells[j].getAttribute("origins")) + 1;  
                                    miorgi = parseInt(table.rows[i].cells[j].getAttribute("origins"));  
                                 
                               if(miorgi == appe){
                                        cellv = j;
                                        shas = 1;
                                    };  
                                    if(duie == mado){
                                        cellz = j;
                                        chas = 1;
                                        };
                                  };
                                  if(shas == 0 || chas ==0){
                                    return;
                                };
                                // cellv = cellStart;
                                // cellz = cellEnd;
                            }else{
                                return;
                            };
                        };
                    }else if(i !== rowStart && i == rowEnd){
                    if(one[1] == 0){
                        if(appe < one[3]){
                            return;
                        }else{
                            let shas = 0;
                            let chas = 0;
                            let mado = one[3];
                            for(let j=0; j<=arra[i]; j++){
                              mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                              if(appe == mado){
                                cellv = j+1;
                                shas = 1;
                                };
                              if(appe == one[3]){
                                shas = 1;
                                };
                              if(duie == mado){
                                cellz = j;
                                chas = 1;
                                };
                            };
                            if(shas == 0 || chas ==0){
                                return;
                            };
                        };
                    }else{
                        let angi =0;
                        for(let n=0; n<one[1]; n++){
                        angi += table.rows[one[0]].cells[n].getAttribute("colspan") ? parseInt(table.rows[one[0]].cells[n].getAttribute("colspan")) : 1; 
                        };

                        if(appe == 0 && duie <= angi){
                            let hote = 0;
                            let chse = 0;
                            for(let j = 0; j <= arra[i]; j++){
                              hote += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                            if(duie == hote){
                                cellv = 0;
                                cellz = j;
                                chse = 1;
                            };
                            };
                            if(chse == 0){
                                return;
                            }   
                        }else if(appe == 0 && duie > angi){
                            return;
                        }else if(appe > 0 && angi > appe){
                            let gondo = 0;
                            let ches = 0;
                            for(let j = 0; j <= arra[i]; j++){
                                gondo += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;
                            if(gondo == appe){
                                cellv = j+1;
                                ches = 1;
                            };
                            };
                            let shas = 0;
                            if(duie == angi + one[3]){
                                shas = 0;
                            };
                            if(duie < angi + one[3] && angi < duie){
                                shas = 0;
                            };
                            if(duie <= angi){
                                let mado = 0;
                                for(let j=0; j<=arra[i]; j++){
                                  mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                                    if(duie == mado){
                                        cellz = j;
                                        shas = 1;
                                        break;
                                    };
                                };
                            };
                        
                            if(ches == 0 || shas == 0){
                                return;
                            };
                        }else if(appe > 0 && angi == appe){
                            return;
                        }else if(appe > 0 && appe > angi){
                            let shas = 0;
                            let chas = 0;
                            if(appe < angi+one[3]){
                               return;     
                            };
                            if(appe >= angi+one[3]){
                                let mado = 0;
                                for(let f=0; f<=arra[i]; f++){
                                  mado += table.rows[i].cells[f].getAttribute("colspan") ? parseInt(table.rows[i].cells[f].getAttribute("colspan")) : 1;  
                                  if(appe == mado){
                                    cellv = f+1;
                                    shas = 1;
                                    };
                                  if(duie == mado){
                                        cellz = f;
                                        chas = 1;
                                    };
                                };
                            };
                            if(shas == 0 || chas ==0){
                                return;
                            };
                        };
                    };
                  }else{
                   
                    let shas = 0;
                    let chas = 0;
                    let mado = 0;
                    for(let j=0; j<=arra[i]; j++){
                      mado += table.rows[i].cells[j].getAttribute("colspan") ? parseInt(table.rows[i].cells[j].getAttribute("colspan")) : 1;  
                      if(appe == mado){
                        cellv = j+1;
                        shas = 1;
                        };
                      if(appe == 0){
                        cellv = 0;
                        shas = 1;
                        };
                      if(duie == mado){
                            cellz = j;
                            chas = 1;
                        };
                    };
                    if(shas == 0 || chas ==0){
                        return;
                    };
                  };
                }else{
                    let sees = 0;
                    let shes = 0;
                    let shas = 0;
                    for(let v=0; v<=arra[i]; v++){
                        sees += table.rows[i].cells[v].getAttribute("colspan") ? parseInt(table.rows[i].cells[v].getAttribute("colspan")) : 1; 
                        if(sees == appe){
                            cellv = v+1;
                            shes = 1;
                        };    
                        if(appe == 0){
                            cellv = 0;
                            shes = 1;
                        };
                        if(sees == duie){
                            cellz = v;
                            shas = 1;
                        };
                    };
                   
                    if(shes == 0 || shas == 0 ){
                        return;
                    };
                };
            };
        }else if(noonmul.length > 0){
           
            let sees = 0;
            let saas = 0;
            let shes = 0;
            let shas = 0;
            if(arra[i] == -1){
              
                continue;
            };
            if(i == rowStart){
                let syys = 0;
                let stts = 0;
                let vfor = 0; //시작셀 
                let wfor = 0; //끝셀
                let kyyr = 0; //선택한 셀의 전체 가로 길이이
                for(let v=0; v<=arra[i]; v++){
                syys = parseInt(table.rows[i].cells[v].getAttribute("colspan"));
                stts = parseInt(table.rows[i].cells[v].getAttribute("origins")); 
                if(stts == frank){
                    vfor = v;
                };
                if(syys + stts == backa){
                    wfor = v;
                };
                }; 

                for(let v=vfor; v<=wfor; v++){
                    kyyr += parseInt(table.rows[i].cells[v].getAttribute("colspan"));
                };
                if(kyyr !== backa - frank){
                    return;
                };
            };
            for(let v=0; v<=arra[i]; v++){
                sees = parseInt(table.rows[i].cells[v].getAttribute("colspan")); 
                saas = parseInt(table.rows[i].cells[v].getAttribute("origins")); 
              
                if(v == 0 && saas >= frank){ //여긴 
                    cellv = v;
                    shes = 1;
                    
                };
                // if(v == 0 && saas < frank){
                //     nogood = 1;
                //     shas = 1;
                //     shes = 1;
                // };
                // if(v ==arra[i] && backa < sees + saas){
                //     nogood = 1;
                // };
                if(v == arra[i] && backa > sees + saas){
                    cellz = v;
                    shas = 1;
                    
                };
                if(saas == frank){
                    cellv = v;
                    shes = 1;
                   
                };
                if(sees + saas == backa){
                    cellz = v;
                    shas = 1;
                   
                };
                if(v == arra[i] && frank > saas){
                   
                    nogood = 1;
                    shas = 1;
                    shes = 1;
                };
                if(v == 0 && backa <= saas){
                   
                    nogood = 1;
                    shas = 1;
                    shes = 1;
                };
                if(v == arra[i] && backa == saas + sees){
                    
                    nogood = 0;
                    cellz = v;
                    shas = 1;
                    shes = 1;
                };
                if(v == arra[i] && backa > saas + sees){
                    
                    shas = 1;
                    shes = 1;
                };
                if(mingi > 0 && i <= mingi){
                    if(sees + saas == frank){
                    shes = 1;
                    cellv = v+1;
                    
                    };
                };
                if(fingi > 0 && i <= fingi){
                    if(backa == saas){
                        shas = 1;
                        cellz = v-1;
                        
                    };
                };
            };
            if(shas == 0 || shes == 0){
               
                document.querySelectorAll('.selected').forEach((a)=>{a.classList.remove("selected");});
                return;
            };
        }else{
            let sees = 0;
            let zees = 0;
            let shes = 0;
            let shas = 0;
            
            for(let v=0; v<=arra[i]; v++){
                sees += table.rows[i].cells[v].getAttribute("colspan") ? parseInt(table.rows[i].cells[v].getAttribute("colspan")) : 1; 
                if(sees == appe){
                    cellv = v+1;
                    shes = 1;
                }; 
                if(appe == 0){
                    cellv = 0;
                    shes = 1;
                };   
                if(sees == duie){
                    cellz = v;
                    shas = 1;
                };
            };
            
            if(shes == 0 || shas == 0 ){
                return;
            };
        };

       
        for(const rosap of noonmul){
            if(rosap[0] == i && rosap[1] == cellv){
                mingi = rosap[2]+i-1;                
            };
            if(rosap[0] == i && rosap[1] == cellz){
                fingi = rosap[2]+i-1;    
            };
        };
        if(nogood == 1){
            continue;
        };
        for (let j = cellv; j <= cellz; j++) {
           
             table.rows[i].cells[j].classList.add("selected");
         };      
    };

//아직 더해야 할 부분 : 시작점이 로우스팬에 걸려 있는 셀 인덱스 교정, 전체 열병합한 로우의 아페와 뒤에 값 충돌
/*
    for (var i = rowStart; i <= rowEnd; i++) {
        var cellv = cellStart;
        var cellz = cellEnd;
        if(cellking > arra[rowEnd]){
            var roce = table.rows[rowEnd].cells.length - 1;
            var lica = 0;
            for(var p = 0; p <= roce; p++){
                lica = table.rows[rowEnd].cells[p].getAttribute('colspan') ? table.rows[rowEnd].cells[p].cellIndex : lica;
            };
            if(lica > cellEnd){
                cellz = cellEnd;
            }else{
            cellz = cellEnd + cellking - arra[rowEnd];
            };
        };

        var rowCells = table.rows[i];
        let firstk =0;
        let jongdap = 0;
        var limits = rowCells.cells.length - 1;
        for(let m=0; m<=arra[i]; m++){
            firstk += rowCells.cells[m].getAttribute("colspan") ? parseInt(rowCells.cells[m].getAttribute("colspan")) : 1;
            if(firstk == lastk){
                jongdap = m;
                console.log("엠을차느나",m, firstk, i);
                break;
            };
            };

        var icy = 0;
        if(limits / cellking < 1){
            for(var k = 0; k<= limits; k++){
               icy = rowCells.cells[k].getAttribute('colspan') ?  rowCells.cells[k].cellIndex : icy ;
               console.log("이곳을 봐", k, icy);
            };
            if( i !== rowEnd){
                if(jongdap == 0){
                    return;
                }else{
                    cellz = jongdap;
                };
            }else{
                cellz = cellEnd;
                console.log("마지막줄", cellz);
            };
        };
      
        console.log("세개다", limits, icy);

        for (var j = cellv; j <= cellz; j++) {
           console.log("이곳이 안이다", rowCells, rowCells.cells[j]);
            rowCells.cells[j].classList.add("selected");
        }        
    }
    */
};


const toggg=(e)=>{
    e.preventDefault();
    document.getElementById(idname).innerHTML = "";
};
const pointa=(e)=>{
    const row = e.target.dataset.info;
    const column = e.target.dataset.non;
    const rese = document.querySelectorAll('.totx td');
    for( let eml of rese){
        eml.style.backgroundColor = '#00ff1d08';
    };
   
    for(let i=1; i<=row; i++){
        for(let j=1; j<=column; j++){
            if(i == 1){
            document.querySelector(`.ichi td:nth-child(${j})`).style.backgroundColor = '#a2ff6ba6';};
            if(i ==2){
            document.querySelector(`.nii td:nth-child(${j})`).style.backgroundColor = '#a2ff6ba6';};
            if(i ==3){
            document.querySelector(`.san td:nth-child(${j})`).style.backgroundColor = '#a2ff6ba6';};
            if(i ==4){
            document.querySelector(`.ssi td:nth-child(${j})`).style.backgroundColor = '#a2ff6ba6';};
            if(i ==5){
            document.querySelector(`.gou td:nth-child(${j})`).style.backgroundColor = '#a2ff6ba6';};
            if(i ==6){
            document.querySelector(`.sichi td:nth-child(${j})`).style.backgroundColor = '#a2ff6ba6';};
                    };
    };
};
const hakjung =(e)=>{
  
    tama(e);
    setpant(!pant);
};
let mson;
const tachi =(e)=>{
    e.preventDefault();
    setpant(!pant);
    mson =`${document.getElementById('jop').getBoundingClientRect().left - 100}`+"px";
    setmms(`${document.getElementById('jop').getBoundingClientRect().left - 100}`+"px");
    //document.getElementsByClassName("toxt").style.left = `${document.getElementById('jop').getBoundingClientRect().left - 100}`+"px";
  
};
const outside=(e)=>{
    
    if(e.target.id == "toxin" || e.target.parentNode.id == "sooja"){
        
        return;
    }
    if(!ref.current.contains(e.target) && !pant){
        setpant(false);
      
    }
    const chaa = 'j';
    const lett = e.target.id;
    let afl = lett.toString();
    if( /^j/.test(afl)){
    
    setidname(afl);
    }
    if(document.getElementById('sooja') && nodak){
        document.querySelectorAll('.selected').forEach((a)=>{a.classList.remove("selected");});
        document.getElementById('sooja').remove();
        document.getElementById("jop").setAttribute("contentEditable", true);
        setnodak(false);
    
     }
};
const keyside=(e)=>{
   
    if(e.key == "Enter"){ e.preventDefault();};
};
const ref = useRef();

useEffect(() => {
   
    if(monjo == true){  return; };
    document.addEventListener('click', outside, true);
    const hangs = document.querySelector("#jea");
    const higi = hangs.querySelectorAll('input');
    higi.forEach(hihi=>{hihi.addEventListener('keydown', keyside, true);}); 
    return () => {
        document.removeEventListener('click', outside, true);
    };
     
}, [idname, monjo, nodak]);

useEffect(() => {
    if (spin && progress < 100) {
      const timer = setTimeout(() => setprogress(prev => prev + 1), 80);
      return () => clearTimeout(timer);
    };
    if(progress == 100){
        setspin(false);
        setmonjo(true);
    };
  }, [progress, spin]);

let drawing = false;
let posi = "";
let presen = document.getSelection();
let mooving = false;

const dragon=(e)=>{
drawing=true;
presen =document.getSelection();
posi=e.pageX;
if(document.getElementById('sooja')){
    document.getElementById('sooja').remove();
}

};

const colorch =(e)=>{
    const comcol = e.target.value;
    const kazo = document.getElementsByClassName("selected");
    for(let i=0; i<kazo.length; i++){
        kazo[i].style.backgroundColor = comcol;
    };
    
};

const dragover=(e)=>{
    if(isMouseDown == false){
        return;
    };
    document.getElementById("jop").setAttribute("contentEditable", false);
    document.getElementById("jop").classList.add("preventselect");
    selectTo(e.currentTarget);
    if(drawing==true){
  
    mooving=true;
if(e.pageX == posi){
drawing=false;
}else{
    drawing=true;
}
    }
};

const dragoff=(e)=>{
    if(nodak == true){
       
        return;
    }
   
    isMouseDown = false;
    const table = e.currentTarget.parentNode.parentNode.parentNode;
    const sisa = table.querySelectorAll(".selected");

   
   // if(mooving == true && presen.isCollapsed == false)
    if(sisa.length >= 2){
const wichi = presen.getRangeAt(0);
const wicha = wichi.cloneContents();
let {anchorNode, anchorOffset, focusNode, focusOffset} = presen;
//wichi.endContainer.parentNode.parentNode.setAttribute("rowspan", "2");
let kee = wichi.endContainer.parentNode.parentNode.getBoundingClientRect();
let jee=wichi.endContainer.parentNode.getBoundingClientRect();
if(wichi.endContainer.parentNode.nodeName == "TD"){
    kee = wichi.endContainer.parentNode.getBoundingClientRect();
}
if(wichi.endContainer.parentNode.parentNode.nodeName == "TD"){
    kee = wichi.endContainer.parentNode.parentNode.getBoundingClientRect();
}
let coka = sisa[sisa.length-1].getBoundingClientRect();
const sooja = document.createElement('div');
sooja.setAttribute("style", `position: absolute; width : 120px; height : 120px; border : 1px solid #45455957; background-color : #a2ff6ba6; top :${coka.top+window.scrollY}px; left : ${coka.right}px;`);
sooja.setAttribute("id","sooja");
const neboo = document.createElement('button');
neboo.innerText="열병합";
neboo.className="kihap";
neboo.addEventListener("click", merged);
const neba = document.createElement('button');
neba.innerText="행추가";
neba.className="hihap";
neba.addEventListener("click", hueru);
const colll = document.createElement('input');
colll.type = "color";
colll.id = "colorcome";
colll.addEventListener("change",colorch);
colll.style = "width: 44%; height: 30px; margin-top:10px; margin-left:3%;";
colll.value = "#ffffff";
sooja.appendChild(neboo);
sooja.appendChild(neba);
sooja.appendChild(colll);
sooja.addEventListener('mouseleave', ()=>{document.getElementById('sooja').remove();
sisa.forEach((a)=>{a.classList.remove("selected");});
document.getElementById("jop").setAttribute("contentEditable", true);
setnodak(false);
});
document.body.append(sooja);
if(wichi.endContainer.parentNode.nodeName == "TD" || wichi.endContainer.parentNode.parentNode.nodeName == "TD"){
    if(wicha.childNodes.length>1 && wicha.firstChild.nodeName=="TD"){
    document.body.append(sooja);
    }
}

drawing=false;
mooving=false;
setnodak(true);
    }else{
        if(document.getElementById('sooja')){
          
            document.getElementById('sooja').remove();
        }
        sisa.forEach((a)=>{a.classList.remove("selected");});
        document.getElementById("jop").setAttribute("contentEditable", true);
        drawing=false;
        mooving=false;
        setnodak(false);
        
    }
};

const merged=(e)=>{
   
    const kaze =  document.getElementsByClassName("selected");
    
const merges = presen.getRangeAt(0);
const stamer = merges.cloneContents();
const mernum = stamer.childNodes.length;

if(kaze.length == 2){

    if(kaze[0].getAttribute('origins') == kaze[1].getAttribute('origins')){
        const table = kaze[1].parentNode.parentNode.parentNode;
        for(let k=kaze[1].cellIndex + 1; k<= table.rows[kaze[1].parentNode.rowIndex].cells.length - 1; k++){
            table.rows[kaze[1].parentNode.rowIndex].cells[k].setAttribute("realindex", table.rows[kaze[1].parentNode.rowIndex].cells[k].cellIndex);
        };
        const oosun = kaze[0].getAttribute("rowspan") ? parseInt(kaze[0].getAttribute("rowspan")) : 1;
        const najoong = kaze[1].getAttribute("rowspan") ? parseInt(kaze[1].getAttribute("rowspan")) : 1;
     
        kaze[1].remove();
        kaze[0].setAttribute("rowspan", oosun+najoong);
        document.getElementById("jop").setAttribute("contentEditable", true);
        kaze[0].classList.remove("selected");
}else{ 
    let hanas = [];
    const banpo = kaze[1].childNodes.length;
  
    for(  let i = 0; i < banpo; i++){
      hanas.push(kaze[1].childNodes[i]);
    };
    for( const kizz of hanas){
    kaze[0].appendChild(kizz);
    };
    const pugong = kaze[0].getAttribute("colspan") ? parseInt(kaze[0].getAttribute("colspan")) : 1;
    const kugong = kaze[1].getAttribute("colspan") ? parseInt(kaze[1].getAttribute("colspan")) : 1;
    const table = kaze[1].parentNode.parentNode.parentNode;
    if(kaze[1].cellIndex !== table.rows[kaze[1].parentNode.rowIndex].cells.length - 1){
    for(let k=kaze[1].cellIndex + 1; k<= table.rows[kaze[1].parentNode.rowIndex].cells.length - 1; k++){
        table.rows[kaze[1].parentNode.rowIndex].cells[k].setAttribute("realindex", table.rows[kaze[1].parentNode.rowIndex].cells[k].cellIndex);
    };
    };
    kaze[1].remove();
    kaze[0].setAttribute("colspan", pugong+kugong);
    document.getElementById("jop").setAttribute("contentEditable", true);
    kaze[0].classList.remove("selected");
};
};

if(kaze.length > 2){
    if(kaze[0].closest("tr").rowIndex !== kaze[kaze.length-1].closest("tr").rowIndex){
        const byten = kaze.length/(kaze[kaze.length-1].closest("tr").rowIndex - kaze[0].closest("tr").rowIndex + 1); 
      
        
        let rowgap = [0];
        let chap = 0;
        for(let h = 1; h < kaze.length; h++){
            if(kaze[0].closest("tr").rowIndex == kaze[h].closest("tr").rowIndex){
                rowgap.push(h);
                continue;
            };
            break;
        };
        for(const gore of rowgap){
            chap += kaze[gore].getAttribute("colspan") ? parseInt(kaze[gore].getAttribute("colspan")) : 1;
        };
        let cellgap = [0];
        let cehap = 0;
        for(let h = 1; h < kaze.length; h++){
            if(kaze[0].getAttribute("origins") == kaze[h].getAttribute("origins")){
                cellgap.push(h);
                continue;
            };
        };
        for(const gore of cellgap){
            cehap += kaze[gore].getAttribute("rowspan") ? parseInt(kaze[gore].getAttribute("rowspan")) : 1;
        };
        if(cellgap.length == kaze.length){
            const table = kaze[0].parentNode.parentNode.parentNode;
            //보류
        };
        for(let k = kaze.length-1; k > 0; k--){
            kaze[k].remove();
        };
        kaze[0].setAttribute("colspan", chap);
        kaze[0].setAttribute("rowspan", cehap);
        document.getElementById("jop").setAttribute("contentEditable", true);
        kaze[0].classList.remove("selected");
       
    }else{
    let colhap = 0;
    let monzi = [];
    const table = kaze[0].parentNode.parentNode.parentNode;
    for( let i = 0; i < kaze.length; i++){
        colhap += kaze[i].getAttribute("colspan") ? parseInt(kaze[i].getAttribute("colspan")) : 1;
        for(let j =0; j < kaze[i].childNodes.length; j++){
        monzi.push(kaze[i].childNodes[j]);
        };
    };
    if(kaze[kaze.length-1].cellIndex !== table.rows[kaze[0].parentNode.rowIndex].cells.length - 1){
    for(let k=kaze[kaze.length-1].cellIndex + 1; k<= table.rows[kaze[0].parentNode.rowIndex].cells.length - 1; k++){
        table.rows[kaze[0].parentNode.rowIndex].cells[k].setAttribute("realindex", table.rows[kaze[0].parentNode.rowIndex].cells[k].cellIndex);
    };
    };
   
    for(let k = kaze.length-1; k > 0; k--){
        kaze[k].remove();
    };
    kaze[0].setAttribute("colspan", colhap);
    for(const kuzz of monzi){
        if(kuzz.innerHTML == "&nbsp;"){
            continue;
        };
    kaze[0].appendChild(kuzz);
    };
    document.getElementById("jop").setAttribute("contentEditable", true);
    kaze[0].classList.remove("selected");
};
};

if(merges.startContainer.parentNode.nodeName == "TD" && mernum >1){
    let mern = 0;
    while(mernum-1>mern){
    merges.startContainer.parentNode.nextSibling.remove();
    mern++;
    }
    mern = 0;
    merges.startContainer.parentNode.setAttribute("colspan", mernum);
}
if(merges.startContainer.parentNode.nodeName == "B" && mernum >1){
    let mern = 0;
    while(mernum-1>mern){
    merges.startContainer.parentNode.parentNode.nextSibling.remove();
    mern++;
    }
    mern = 0;
    merges.startContainer.parentNode.parentNode.setAttribute("colspan", mernum);
}
    document.getElementById('sooja').remove();
    setnodak(false);
};

const hueru=(e)=>{
    const jiafa = presen.getRangeAt(0);
    const jiale = jiafa.cloneContents();
    const jianum = jiale.childNodes.length;
    const kaze =  document.getElementsByClassName("selected");
    const kamze = kaze[0].parentNode.parentNode.parentNode;
    const kamso = kamze.rows.length - 1;
    const kemso = kamze.rows[kamso].cells.length-1;
    const juicn = kaze[0].parentNode.parentNode.parentNode.getAttribute("oricells");
    // const jiaone = document.createElement('tr');
    // for(let i =0; i<jianum; i++){
    //     const tdbox = document.createElement('td');
    //     const txbox = document.createTextNode('cell');
    //     tdbox.appendChild(txbox);
    //     jiaone.appendChild(tdbox);
    // };

    // const jiaon = document.createElement('tr');
    // for(let i =0; i<kemso; i++){
    //     const tdbox = document.createElement('td');
    //     const txbox = document.createTextNode('cell');
    //     tdbox.appendChild(txbox);
    //     jiaon.appendChild(tdbox);
    // };
    const takam = kamze.insertRow();
  //  const jiaon =document.createElement('tr');
    for(let j=0; j<=juicn; j++){
        const cell = takam.insertCell(j);
     //   const cell = document.createElement('td');
        cell.setAttribute("height", "18px");
        cell.setAttribute("width", "150px");
        cell.setAttribute("origins", j);
        cell.setAttribute("colspan", 1);
        const texing = document.createElement('p');
    
        const cellin = document.createTextNode('\u00a0');
        texing.appendChild(cellin);
        cell.appendChild(texing);
      
      
    };
    //kamzzz.appendChild(jiaon);

if(jiafa.startContainer.parentNode.nodeName == "TD"){
    let circl = jiafa.startContainer.parentNode.previousSibling;
    while(circl){
        circl.setAttribute("rowspan", "2");
        circl= circl.previousSibling;
    };
    let hubang = jiafa.endContainer.parentNode.nextSibling;
    while(hubang){
        hubang.setAttribute("rowspan", "2");
        hubang = hubang.nextSibling;
    };
    document.getElementById('sooja').remove();
}

if(jiafa.startContainer.parentNode.nodeName == "B"){
    let circl = jiafa.startContainer.parentNode.parentNode.previousSibling;
    while(circl){
        circl.setAttribute("rowspan", "2");
        circl= circl.previousSibling;
    };
    let hubang = jiafa.endContainer.parentNode.parentNode.nextSibling;
    while(hubang){
        hubang.setAttribute("rowspan", "2");
        hubang = hubang.nextSibling;
    };
}
    //kamze.insertAdjacentElement('afterend', jiaon);
   
   // jiafa.commonAncestorContainer.insertAdjacentElement('afterend', jiaone);

   
};

    const kelly=(e)=>{
        if(e.target.checked){
            coo.push(e.target.value);
            setcoo(coo);
            setcate(false);
        }else{
            const kim = coo.filter(a=>a !== e.target.value);
            setcoo(kim);
        }
        
    };

    const vos=(e)=>{
      
        setbbal(e.target.name);
    };
    const bos=(e)=>{
        setbbal('');
        const {name, value} = e.target;
            const errora = document.getElementById(`${name}-error`);
        if (errora) {    
        if (!value.trim()) {
            if (name === 'kog') errora.textContent = '공모전 명칭을 입력해주세요';
            if (name === 'designer') errora.textContent = '주최사를 입력해주세요';
            if (name === 'holder') errora.textContent = '주관사를 입력해주세요';
            if (name === 'sizak') errora.textContent = '시작일을 입력해주세요';
            if (name === 'zong') errora.textContent = '마감일을 입력해주세요';
          } else {
            errora.textContent = '';
          };
        };
    };

  return(

    <>
    <Modal isOpen={spin} style={customStyles}>
    <div style={{ textAlign: 'center' }}>
        <h3>파일 업로드 중...</h3>
        <div 
          className="pure-material-progress-circular-determinate" 
          style={{ '--value': progress }}
        ></div>
        <p>{progress}% 완료</p>
      </div>
        {/* <progress className="pure-material-progress-circular"/> */}
    </Modal>
    {monjo == true ? <div className='gongjian'><p>내용 확인 후 등록하겠습니다!</p>
    <Link to="/" className="kahho">메인페이지</Link></div> : 
    <div>
        <br/>
        <form onSubmit={sss}>
        <div style={{width : "460px", margin : "0 auto"}} id='jea'>
           
           <h3><label for="title">공모전 명칭</label><span id="kog-error" className='jural'></span></h3>
           <span className={bbal == 'kog' ? 'j1 j2' : 'j1'}>
               <input type='text' name='kog' id='title' onFocus={vos} onBlur={bos} required />
           </span>

           <h3><label for="design">주최사</label><span id="designer-error" className='jural'></span></h3>
           <span className={bbal == 'designer' ? 'j1 j2' : 'j1'}>
               <input type='text' name='designer' id='design' onFocus={vos} onBlur={bos} required/>
           </span>

           <h3><label for="hold">주관사</label><span id="holder-error" className='jural'></span></h3>
           <span className={bbal == 'holder' ? 'j1 j2' : 'j1'}>
               <input type='text' name='holder' id='hold' onFocus={vos} onBlur={bos} required/>
           </span>

           <h3><label for="stan">시작일</label><span id="sizak-error" className='jural'></span></h3>
           <span className={bbal == 'sizak' ? 'j1 j2' : 'j1'}>
               <input type='date' name='sizak' id='stan' onFocus={vos} onBlur={bos} required/>
           </span>

           <h3><label for="zan">마감일</label><span id="zong-error" className='jural'></span></h3>
           <span className={bbal == 'zong' ? 'j1 j2' : 'j1'}>
               <input type='date' name='zong' id='zan' onFocus={vos} onBlur={bos} required/>
           </span>

           <h3><label for="tel">연락처</label></h3>
           <span className={bbal == 'tels' ? 'j1 j2' : 'j1'}>
               <input type='text' name='tels' id='tel' onFocus={vos} onBlur={bos} required/>
           </span>

           <h3><label for="hpage">홈페이지</label></h3>
           <span className={bbal == 'wpage' ? 'j1 j2' : 'j1'}>
               <input type='text' name='wpage' id='hpage' onFocus={vos} onBlur={bos} required/>
           </span>

           <h3 id="haca"><label for="cateb">분류</label>{cate && <span className='cateco'>카테고리를 선택해주세요!</span>}</h3>
           <span>
                <input type='checkbox' id='idea' name='idea' value='아이디어' onChange={kelly} className='selca'/><label for='idea'>아이디어</label>
                <input type='checkbox' id='writing' name='idea' value='글쓰기' onChange={kelly} className='selca'/><label for='writing'>글쓰기</label>
                <input type='checkbox' id='slogan' name='idea' value='네이밍' onChange={kelly} className='selca'/><label for='slogan'>네이밍</label>
                <input type='checkbox' id='science' name='idea' value='과학' onChange={kelly} className='selca'/><label for='science'>과학</label>
                <br/>
                <p className='ddio'></p>
                <input type='checkbox' id='contents' name='idea' value='콘텐츠' onChange={kelly} className='selca'/><label for='contents'>콘텐츠</label>
                <input type='checkbox' id='article' name='idea' value='논문' onChange={kelly} className='selca selpu'/><label for='article'>논문</label>
                <input type='checkbox' id='activity' name='idea' value='대외활동' onChange={kelly} className='selca selpu'/><label for='activity'>대외활동</label>
                <input type='checkbox' id='educate' name='idea' value='교육' onChange={kelly} className='selca selpu'/><label for='educate'>교육</label>
           </span>

           <h3><span>홍보포스터</span><span id="piano" className='npo'></span></h3>
           {/* <span className={bbal == 'poster' ? 'j1 j2' : 'j1'}> */}
           <span className='katt'>
                <label for="poster">파일찾기</label>
                <input type='file' name='poster' id='poster' onChange={checkmin} />
                <div id="yorksh"></div> 
           </span>

           <h3><span>안내자료</span><span id="giano" className='npo'></span></h3>
           <span className='katt'>
                <label for="ufo">파일찾기</label>
                <input type='file' name='info' onChange={checkfo} id='ufo' multiple/>
                <div id="worksh"></div>    
           </span>

           <h3><label for="yora">공모요강</label><span id="jopab" className='jural'></span></h3>
           <span style={{display : "block", width : "100%", height : "30px", marginBottom : "-2px"}}>
                <button id="toxin" className='taxim' onClick={bbold}><img src={process.env.PUBLIC_URL+"/bold-m.png"} className='intax'/></button>
                <button id="toxin" className='taxim' onClick={tachi}><img src={process.env.PUBLIC_URL+"/table-m.png"} className='intax'/></button>
                <button id="toxin" className='taxim' onClick={toggg}><img src={process.env.PUBLIC_URL+"/trash-m.png"} className='intax'/></button>
           </span>
        </div>
        
            <table id="jea" style={{borderTop: 0}}>
            <tbody>
                    <div ref={ref} className={pant ? 'totx' : 'totxact'} style={{left : mms}}>
                    <table style={{borderTop:"1px solid #c7d5c7"}}><tbody>
                    <tr className='ichi'>
                        <td onMouseOver={pointa} data-info="1" data-non="1" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="1" data-non="2" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="1" data-non="3" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="1" data-non="4" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="1" data-non="5" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="1" data-non="6" onClick={hakjung}></td>
                    </tr>
                    <tr className='nii'>
                        <td onMouseOver={pointa} data-info="2" data-non="1" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="2" data-non="2" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="2" data-non="3" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="2" data-non="4" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="2" data-non="5" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="2" data-non="6" onClick={hakjung}></td>
                    </tr>
                    <tr className='san'>
                        <td onMouseOver={pointa} data-info="3" data-non="1" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="3" data-non="2" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="3" data-non="3" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="3" data-non="4" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="3" data-non="5" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="3" data-non="6" onClick={hakjung}></td>
                    </tr>
                    <tr className='ssi'>
                        <td onMouseOver={pointa} data-info="4" data-non="1" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="4" data-non="2" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="4" data-non="3" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="4" data-non="4" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="4" data-non="5" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="4" data-non="6" onClick={hakjung}></td>
                    </tr>
                    <tr className='gou'>
                        <td onMouseOver={pointa} data-info="5" data-non="1" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="5" data-non="2" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="5" data-non="3" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="5" data-non="4" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="5" data-non="5" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="5" data-non="6" onClick={hakjung}></td>
                    </tr>
                    <tr className='sichi'>
                        <td onMouseOver={pointa} data-info="6" data-non="1" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="6" data-non="2" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="6" data-non="3" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="6" data-non="4" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="6" data-non="5" onClick={hakjung}></td>
                        <td onMouseOver={pointa} data-info="6" data-non="6" onClick={hakjung}></td>
                    </tr>
                    </tbody></table>
                    </div>
                <tr>
                    <td style={{borderBottom : "none"}}>  
                    <div id='jop' contentEditable='true' className='pluswrite'>
                    </div>
                    </td>
                </tr>
               
            </tbody>
            </table>
            <div className='maggi'><button type="submit" className='maggic2'>등록</button></div>
        </form>
        
       
    <div ref={nana}></div>
    </div>}
    </>
  );
};


const Motex = ({ user, children }) => {
    const omgiza = useNavigate();

    if(Object.hasOwn(user,"brand")){
        return children;
    }else if(Object.hasOwn(user,"pride")){
       
        omgiza('/', {replace: true});
        alert("기업회원 전용 서비스입니다. 기업회원으로 로그인해주세요!");
        window.history.back();
        return (<div style={{height:"600px"}}></div>);
    }else{
        return <Navigate to='/join' state={{kind : "biz"}} replace/>;
    };
};


export {Sins,Motex};